import styled from 'styled-components';
import Col from '~/grid/Col';
import Row from '~/grid/Row';

const FooterBigLinksWrapperColStyled = styled(Col)`
  display: flex;
  flex-direction: column;
  @media (${(props) => props.theme.footer.mobileSwitch}) {
    gap: 24px;
  }
`;

export const RowStyled = styled(Row)`
  @media (${(props) => props.theme.footer.mobileSwitch}) {
    gap: 12px;
  }
`;

export default FooterBigLinksWrapperColStyled;
